import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { z } from "zod";

/**
 * Tiny product-analytics sink. Used to measure Pro intent: which teaser was
 * tapped, whether the upgrade sheet opened, and who asked for Pro.
 */
export const trackEvent = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) =>
    z
      .object({
        name: z.string().min(1).max(60),
        source: z.string().max(60).optional(),
        plan: z.string().max(30).optional(),
        props: z.record(z.string(), z.unknown()).optional(),
      })
      .parse(d ?? {}),
  )
  .handler(async ({ context, data }) => {
    const { error } = await context.supabase.from("product_events").insert({
      user_id: context.userId,
      name: data.name,
      source: data.source ?? null,
      plan: data.plan ?? null,
      props: (data.props ?? {}) as any,
    });
    if (error) return { ok: false };
    return { ok: true };
  });
